<template>
  <div>
    <b-modal
      v-model="showModalCongrats"
      hide-footer
      :hide-header="showModalHeader"
      centered
      size="sm"
      title="Congratulations!"
      ok-title=" I got it"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div class="d-block text-center">
        <p class="h5">
          You earned
        </p>
        <p class="text-aside01 text-bigger">
          {{ points }}
        </p>
        <p class="text-uppercase h5 text-aside01">
          Points
        </p>
        <div class="p-3 h5">
          <p class="m-0">
            for
          </p>
          <p class="m-0 font-weight-bold">
            {{ skill }}
          </p>
        </div>
        <p class="text-main h5 p-3">
          Keep it up!
        </p>
      </div>
      <b-button class="bg-main" block @click="router">
        Okay
      </b-button>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    skill: String,
    router: Function,
    points: String,
  },
  data() {
    return {
      showModalCongrats: false,
    };
  },
  computed: {
    showModalHeader() {
      if (this.points >= 3) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.text-bigger {
  font-size: 5em;
  font-weight: 600;
  line-height: 1em;
}
</style>
